<template lang="pug">
  Layout
    FormWrapper(type="user")
      template( v-slot:default="props")
        UserForm(
          :model="props.model",
          :validate="props.validate",
          :valid="props.valid",
        )
</template>

<script>
import Layout from '@/layouts/User.vue';
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import UserForm from '@/components/forms/User.vue';

export default {
  components: {
    FormWrapper,
    Layout,
    UserForm,
  },
};
</script>
